export enum RSIReport {
    Sensitive = 1,
    Intermediate = 2,
    Resistant = 3
}